export default __webpack_public_path__ + "static/media/close.0f4f6aef.svg";